<template>
    <div :class="classNamesElement">
        <label v-if="label" :for="id"><translate>{{ label }}</translate></label>
        <div class="form-element--radio">
            <input class="form-input" type="radio" :name="name" :id="id" :value="value" v-model="proxyChecked" :required="required" :disabled="disabled">
            <label :for="id" class="form-option"><translate>{{ option }}</translate> </label>
            <span v-if="errorOrInfo" class="form-info">{{ errorOrInfo }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormRadio',
    props: {
        checked: {
            type: [String, Number, Boolean],
            default: null,
        },
        value: {
            type: [String, Number, Boolean],
            default: null,
        },
        id: {},
        name: {},
        label: {},
        required: {},
        option: {},
        disabled: {},
        error: {},
    },
    emits: ['update:checked'],
    computed: {
        proxyChecked: {
            get() {
                return this.checked === true ? 1 : this.checked;
            },
            set(val) {
                this.$emit('update:checked', val);
            },
        },
        classNamesElement() {
            let classNames = ['form-element'];
            if (this.error) classNames.push('form-element--error');

            return classNames;
        },
        errorOrInfo() {
            return this.error ? this.error : '';
        },
    },
};
</script>
